// extracted by mini-css-extract-plugin
module.exports = {"form-team-list":"form-team-list","item-list":"item-list","team-text":"team-text","score":"score","is-lose":"is-lose","is-win":"is-win","team-item":"team-item"};